import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'MEDIA_UPDATE',
    smsDelete : 'MEDIA_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        media: [],
      
        media_detail:{},

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        mediaLoading: false,
        mediaError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_MEDIA(state, media) {
            state.media = media;
        },

        SET_MEDIA_DETAIL(state, detail) {
            state.media_detail = detail;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        MEDIA_LOADING (state, loading) {
            state.mediaLoading = loading;
        },

        MEDIA_ERROR (state, hasError) {
            state.mediaError = hasError;
        }
    },

    actions: {
        //Media
        async addMedia ({commit, dispatch}, payload) {
            commit('MEDIA_LOADING', true);
            commit('MEDIA_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_media, payload.media, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchMedia')
               
                return response

            }catch (e) {
                commit('MEDIA_ERROR', true);
            }finally {
                commit('MEDIA_LOADING', false);
            }
        },

        async fetchMediaDetail ({ commit },payload) {
            commit('MEDIA_LOADING', true);
            commit('MEDIA_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_media_details + payload, config);
                let response = result.data.data

                commit('SET_SLIDER_DETAIL', response);

            } catch(error) {
                commit('MEDIA_ERROR', true);
            }
            finally {
                commit('MEDIA_LOADING', false);
            }
        },

        async fetchMedia ({ commit }) {
            commit('MEDIA_LOADING', true);
            commit('MEDIA_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.media_list, config);
                let response = result.data

                commit('SET_MEDIA', response.data);

            } catch(error) {
                commit('MEDIA_ERROR', true);
            }
            finally {
                commit('MEDIA_LOADING', false);
            }
        },
    
        async updateMedia ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_media+payload.id, payload.media, config).then(result=>{
                    let data = result.data
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchMedia')
                return response

            }catch (e) {
                commit('MEDIA_ERROR', true);
            }finally {
                commit('MEDIA_LOADING', false);
            }
        },

        async deleteMedia({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.media_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchMedia')
            
            return response
        }
    },

    getters: {}
}
